import * as React from 'react'
import { SVGProps } from 'react'
const SvgPensil = (props: SVGProps<SVGSVGElement>) => (
  <svg width={15} height={14} viewBox="0 0 15 14" fill="none" {...props}>
    <g clipPath="url(#a)" fill="#146C92">
      <path d="M9.198 2.01 4.242 9.742l2.1 1.347L11.3 3.356 9.198 2.009ZM11.537 2.98 9.436 1.634l.581-.907a.53.53 0 0 1 .732-.16l1.243.796a.49.49 0 0 1 .148.676l-.603.94v.001ZM3.986 11.952l.082-1.925 2.101 1.347-1.738.867a.308.308 0 0 1-.445-.29Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(.874 .161)" d="M0 0h14v13H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgPensil
